import { createReducer, on } from '@ngrx/store';
import * as CoreActions from './actions';
import { ICoreState, initialCoreState } from './state';

export const coreReducer = createReducer(
  initialCoreState,
  on(CoreActions.signInAttempt, (state, { credentials }): ICoreState => ({
    ...state,
    authError: null,
    pendingUsername: credentials.usuarioLogin,
  })),
  on(CoreActions.signInTwoFactorRequired, (state, { encryptedUser, intermediateToken, userCode }): ICoreState => ({
    ...state,
    authStep: 'two-factor',
    pendingEncryptedUser: encryptedUser,
    pendingIntermediateToken: intermediateToken,
    pendingUserCode: userCode ?? null,
  })),
  on(CoreActions.setAuthData, (state, { user, token }): ICoreState => ({
    ...state,
    user,
    token,
    authStep: 'credentials',
    authError: null,
    pendingUsername: null,
    pendingEncryptedUser: null,
    pendingIntermediateToken: null,
    pendingUserCode: null,
  })),
  on(CoreActions.signInError, (state, { error }): ICoreState => ({
    ...state,
    authError: error,
  })),
  on(CoreActions.signOut, (state): ICoreState => ({
    ...state,
    user: null,
    token: null,
    authStep: 'credentials',
    pendingUsername: null,
    pendingEncryptedUser: null,
    pendingIntermediateToken: null,
    pendingUserCode: null,
  })),
  on(CoreActions.toggleSidenav, (state): ICoreState => ({
    ...state,
    sidenavOpened: !state.sidenavOpened,
  })),
  on(CoreActions.setSidenavOpened, (state, { opened }): ICoreState => ({
    ...state,
    sidenavOpened: opened,
  }))
);
